const initialState = {
    pending: false,
    detailsPending: false,
    stationsPending: false,
    reports: [],
    selectedReport: null,
    stationsForReport: [],
    error: null
};

const weatherStationStatusReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_WEATHER_STATION_STATUS_REPORTS_PENDING':
            return {
                ...state,
                pending: true,
                error: null
            };
        case 'GET_WEATHER_STATION_STATUS_REPORTS_SUCCESS':
            return {
                ...state,
                pending: false,
                reports: action.reports,
                error: null
            };
        case 'GET_WEATHER_STATION_STATUS_REPORTS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'REQUEST_WEATHER_STATION_STATUS_REPORT_SUCCESS':
            return {
                ...state,
                pending: false,
                error: null
            };
        case 'GET_WEATHER_STATION_STATUS_REPORT_PENDING':
            return {
                ...state,
                detailsPending: true,
                selectedReport: null,
                error: null
            };
        case 'GET_WEATHER_STATION_STATUS_REPORT_SUCCESS':
            return {
                ...state,
                detailsPending: false,
                selectedReport: action.report,
                error: null
            };
        case 'GET_WEATHER_STATION_STATUS_REPORT_ERROR':
            return {
                ...state,
                detailsPending: false,
                error: action.error
            };
        case 'GET_STATIONS_FOR_STATUS_REPORT_PENDING':
            return {
                ...state,
                stationsPending: true,
                error: null
            };
        case 'GET_STATIONS_FOR_STATUS_REPORT_SUCCESS':
            return {
                ...state,
                stationsPending: false,
                stationsForReport: action.stations,
                error: null
            };
        case 'GET_STATIONS_FOR_STATUS_REPORT_ERROR':
            return {
                ...state,
                stationsPending: false,
                error: action.error
            };
        case 'CLEAR_WEATHER_STATION_STATUS_REPORT':
            return {
                ...state,
                selectedReport: null
            };
        default:
            return state;
    }
};

export default weatherStationStatusReportsReducer;
